/**
 * Sticky ticket bar on single event pages (kpop/event-bar).
 *
 * The bar is a zero-height sticky anchor under the site header. Once the event
 * title has scrolled up behind the header, the bar slides in; scrolling back
 * up hides it again. It stays `inert` while hidden so its duplicate ticket link
 * is not in the tab order or the accessibility tree.
 */
export function initEventBar() {
	const bar = document.querySelector('[data-event-bar]');
	const title = document.querySelector('.event-intro__title');
	if (!bar || !title) return;

	const header = document.querySelector('.wp-site-blocks > header');
	let top = 0;
	let frame = 0;

	// Where the sticky header ends: its sticky `top` (non-zero under the admin
	// bar) plus its own height.
	const measure = () => {
		top = header ? (Number.parseFloat(getComputedStyle(header).top) || 0) + header.offsetHeight : 0;
		bar.style.setProperty('--event-bar-top', `${top}px`);
	};

	const update = () => {
		frame = 0;
		const on = title.getBoundingClientRect().bottom < top;
		bar.classList.toggle('is-on', on);
		bar.inert = !on;
	};

	const schedule = () => {
		if (!frame) frame = requestAnimationFrame(update);
	};

	measure();
	update();
	window.addEventListener('scroll', schedule, { passive: true });
	window.addEventListener('resize', () => {
		measure();
		schedule();
	});
}
